import { useRef } from 'react';
import { useIsFetching } from 'react-query';

import { useSubscribeQuery } from './useSubscribeQuery';

export const useIsLoading = (queryKeys) => {
  const dataRef = useRef({});
  useSubscribeQuery(queryKeys, (query) => {
    dataRef.current[JSON.stringify(query.queryKey)] = !!query.state.data;
  });
  const isFetching = useIsFetching(queryKeys) > 0;
  const dataList = Object.values(dataRef.current);
  const isAllDataLoaded = dataList.reduce(
    (result, hasData) => result || hasData,
    true
  );

  return dataList.length === 0 || (isFetching && !isAllDataLoaded);
};
